import { TransitionState } from "../GameState"

enum Keys {
    DEBUG_MODE = "WorldDEBUG_MODE",
    ECIG_101_DESTINATION = "WorldECIG_101_DESTINATION",
}

export class WorldRepo {

    /**
     * If nothing is saved it will default to false, so prod is always prod. (Unless you manually add this to local
     * storage in prod.)
     *
     * @returns {boolean}
     */
    static isDebug = (): boolean => {
        const savedValue = localStorage.getItem(Keys.DEBUG_MODE)
        if (savedValue) {
            return savedValue === true.toString()
        }
        return false
    }

    static isDebugModeSaved = (): boolean => {
        return !!localStorage.getItem(Keys.DEBUG_MODE)
    }

    static toggleDebugMode = () => {
        WorldRepo.setDebugMode(!WorldRepo.isDebug())
    }

    static setDebugMode = (debugMode: boolean) => {
        localStorage.setItem(Keys.DEBUG_MODE, debugMode.toString())
    }

    static getEcig101Destination = (): TransitionState => {
        const gameStateString = localStorage.getItem(Keys.ECIG_101_DESTINATION)
        if (gameStateString) {
            return TransitionState[gameStateString]
        } else {
            return TransitionState.TOUR_INTRO
        }
    }

    static setEcig101Destination = (gameState: TransitionState) => {
        localStorage.setItem(Keys.ECIG_101_DESTINATION, gameState)
    }
}
